import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import ShortLogoIcon from "./ui-icons/header/ShortLogoIcon";
import { twMerge } from "tailwind-merge";

const LoadingOpBg = (props: any) => {
    const { customWrapperClass } = props;
    return (
        <FlexRow style={{ zIndex: 500 }} className={twMerge(
            "flex flex-row place-content-center absolute left-0 w-full h-full bg-white/75 items-center justify-center",
            customWrapperClass
        )}>
            <FlexCol className="flex flex-col animate-spin max-w-[24px] max-h-[24px]">
                <ShortLogoIcon />
            </FlexCol>
        </FlexRow>
    );
};

export default LoadingOpBg;
